import { useMemo } from 'react';
import {
  getGetReferenceTableItemsQueryKey,
  useGetReferenceTableItem,
  useGetReferenceTableItems,
  getReferenceTableItems,
} from 'api-client';
import { ReferenceTableItemMapper } from './mapper';
import { queryClient as moduleQueryClient } from 'common/infrastructure/remoteState/persistQueryClient';
import TenantRepository from 'common/infrastructure/tenant/repository';

const ReferenceTableItemRepository = {
  useReferenceTableItems(referenceTableId = '') {
    const tenantId = TenantRepository.getCurrentTenantPid();

    const useQueryResponse = useGetReferenceTableItems(
      tenantId,
      { referenceTableId },
      {
        query: {
          enabled: !!referenceTableId,
        },
      }
    );

    const referenceTableItemEntities = useMemo(() => {
      if (!useQueryResponse?.data || !Array.isArray(useQueryResponse.data)) {
        return [];
      }
      return useQueryResponse.data.map(ReferenceTableItemMapper.fromDTO);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(useQueryResponse?.data)]);

    return {
      ...useQueryResponse,
      referenceTableItemEntities,
    };
  },

  useReferenceTableItem(referenceTableId: string, referenceTableRecordId: string) {
    const tenantId = TenantRepository.getCurrentTenantPid();

    const useQueryResponse = useGetReferenceTableItem(tenantId, {
      referenceTableId,
      referenceTableItemId: referenceTableRecordId,
    });

    const referenceTableItemEntity = useMemo(() => {
      if (!useQueryResponse?.data) {
        return null;
      }
      return ReferenceTableItemMapper.fromDTO(useQueryResponse.data);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(useQueryResponse?.data)]);

    return {
      ...useQueryResponse,
      referenceTableItemEntity,
    };
  },

  async prefetchReferenceTableItems(referenceTableId: string) {
    const tenantId = TenantRepository.getCurrentTenantPid();

    const queryKey = getGetReferenceTableItemsQueryKey(tenantId, { referenceTableId });
    await moduleQueryClient.prefetchQuery({
      queryKey,
      queryFn: () => getReferenceTableItems(tenantId, { referenceTableId }),
    });
  },
};

export default ReferenceTableItemRepository;
